var $cbed386491128668$exports = {};
$cbed386491128668$exports = {
    "collapse": `Zwi\u{144}`,
    "expand": `Rozwi\u{144}`
};


export {$cbed386491128668$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
